// Keycloak reports session timestamps in seconds and credential timestamps in
// milliseconds. Branding them keeps the two from being passed interchangeably.
export type EpochSeconds = number & { readonly __unit: "seconds" }
export type EpochMillis = number & { readonly __unit: "milliseconds" }

export const epochSeconds = (value: number): EpochSeconds =>
  value as EpochSeconds

export const epochMillis = (value: number): EpochMillis => value as EpochMillis

export const secondsToDate = (value: EpochSeconds): Date =>
  new Date(value * 1000)

export const millisToDate = (value: EpochMillis): Date => new Date(value)
